export enum PAGINATION {
  DEFAULT_PAGE = 1,
  DEFAULT_LIMIT = 10,
  MAX_LIMIT = 50,
  ALL_ITEMS = 1_000_000,
}

export enum BOOLEAN_ENUM {
  TRUE = 'true',
  ONE = '1',
  FALSE = 'false',
  ZERO = '0',
}
